import MatchStatus from "@ihs-widget/components/StatsConsole/Widgets/H2HWidget/parts/common/MatchStatus/MatchStatus";
import { useFormatDate } from "@ihs-widget/components/StatsConsole/Widgets/H2HWidget/parts/H2H/hooks/useFormatDate";
import { useTranslations } from "../../../../../../translation/TranslationContext";
import { T } from "@ihs-widget/utils/enums";
import { useLanguage } from "@ihs-widget/utils/hooks/useLanguage";
import { useEffect } from "react";
interface RowProps {
    date: string;
    league: string;
    homeTeam: string;
    homeScore: number;
    awayScore: number;
    awayTeam: string;
    status?: typeof T.W | typeof T.F | typeof T.D | null;
    isLatestMatch?: boolean;
    homeTeamInPlay?: boolean;
    awayTeamInPlay?: boolean;
    showPenaltyScores?: boolean;
    penaltyHomeScore?: number | null;
    penaltyAwayScore?: number | null;
    matchStatus?: string | null;
    homeTeamEliminated?: boolean;
    awayTeamEliminated?: boolean;
}


export const H2HMatchRow = ({ 
    date, 
    league, 
    homeTeam, 
    homeScore, 
    awayScore, 
    awayTeam, 
    status = null, 
    isLatestMatch = false, 
    homeTeamInPlay = false, 
    awayTeamInPlay = false,
    showPenaltyScores = false,
    penaltyHomeScore = null,
    penaltyAwayScore = null,
    matchStatus = null,
    homeTeamEliminated = false,
    awayTeamEliminated = false
}: RowProps) => {
    const language = useLanguage();
    const t = useTranslations(language);        

    return (
        <div className={penaltyHomeScore !== null && penaltyAwayScore !== null ? styles.containerPenaltyScores : styles.container}>
            <div className={styles.headerRow}>
                <div>{useFormatDate(date)}</div>
                <div className={styles.league}>{league}</div>
            </div>
            <div className={styles.matchRow}>
                <div className={`${styles.scoreContainer} ${isLatestMatch ? '' : ''} ${penaltyHomeScore !== null && penaltyAwayScore !== null ? 'mb-[8px]' : 'mb-[16px]'}`}>
                    <div className={styles.scoreContainerWrapper}>
                        <div className={`${styles.matchStatusWrapper} ${status ? 'justify-between' : 'justify-end'}`}>
                            {status && <MatchStatus mr="mr-[8px]" status={status} />}
                            <div className={`${homeTeamEliminated ? styles.teamNameHomeEliminated : homeTeamInPlay ? styles.teamNameHomeInPlay : styles.teamNameHome}`}
                            >{homeTeam}</div>
                        </div>
                        <div className={styles.score}>
                            {matchStatus === 'not_started' 
                                ? '-'
                                : `${homeScore}-${awayScore}`
                            }
                        </div>
                        
                        <div className="flex-1 min-w-0">
                            <div className={`${awayTeamEliminated ? styles.teamNameAwayEliminated : awayTeamInPlay ? styles.teamNameAwayInPlay : styles.teamNameAway}`}
                            style={{ fontWeight: awayTeamInPlay ? '500' : '400' }}
                            >{awayTeam}</div>
                        </div>
                    </div>
                </div>
            </div>
            {penaltyHomeScore !== null && penaltyAwayScore !== null && (
                <div className={styles.penaltyScores}>
                    {(t[`InHouseStats.PenaltyScoresShort`])} {penaltyHomeScore} - {penaltyAwayScore}
            </div>
            )}
        </div>
    )
}

const styles = {
    container: "w-full h-[72px] border-base080 border-b dark:border-base120 flex flex-col justify-center items-center",
    containerPenaltyScores: "w-full h-[96px] border-base080 border-b dark:border-base120 flex flex-col justify-center items-center",
    headerRow: "flex flex-row justify-between items-center text-[12px] leading-[16px] text-base0 dark:text-base090 font-robotoRegular font-normal mt-[8px] mb-[16px] w-full",
    matchRow: "flex flex-row justify-between items-center w-full gap-[8px]",
    scoreContainer: "flex flex-row justify-center items-center  text-[12px] leading-[16px] text-base120 dark:text-monoY font-robotoRegular font-normal w-full",
    scoreContainerWrapper: "flex flex-row justify-between items-center w-full",
    matchStatusWrapper: "flex-1 min-w-0 flex flex-row justify-between marker:items-center",
    score: "flex-none mx-[8px] font-robotoMedium font-medium",
    teamNameHome: "truncate text-right w-full font-robotoRegular font-normal",
    teamNameAway: "truncate text-left font-robotoRegular font-normal",
    teamNameHomeInPlay: "truncate text-right w-full font-robotoMedium font-medium",
    teamNameAwayInPlay: "truncate text-left font-robotoMedium font-medium",
    teamNameHomeEliminated: "truncate text-right w-full font-robotoRegular font-normal text-[#6B6B6B] dark:text-base090",
    teamNameAwayEliminated: "truncate text-left font-robotoRegular font-normal text-[#6B6B6B] dark:text-base090",
    league: "max-w-[244px] truncate text-right",
    penaltyScores: "mb-[16px] text-[12px] leading-[16px] text-base120 dark:text-monoY font-robotoMedium font-medium w-full text-center"
  };
